module.exports = require('./helpers/bundle-url').getBundleURL('cQKSD') + "lexus-car.5f267fd4.png";